import {
  LinkComponent,
  LinkComponentProps
} from '@carrot/style-components/button/components/as-link';
import { tv } from 'tailwind-variants';

const style = tv({
  base: ['text-paragraph']
});

type Props = Omit<LinkComponentProps, 'styles' | 'className' | 'as'>;

export const MenuItemSecondary = (props: Props) => {
  return (
    <LinkComponent
      {...props}
      as="link"
      styles={{
        alignment: 'left',
        variant: 'borderless',
        size: 'small'
      }}
      className={style()}
    />
  );
};
